<template lang='pug'>
  bf-flex.bf-modal.centered.component(v-if='show')
    slot
</template>

<script>
  export default {
    name: 'bf-modal.component',

    props: {
      show: { type: Boolean, default: false },
      scrolled: Boolean
    }
  }
</script>

<style scoped lang='stylus'>
  @keyframes appear
    from
      background-color var(--clr-blue-light)
      border-color var(--clr-blue-light)
      transform scale(0)
      border-width 0
    to
      background-color white
      transform scale(1)

  .bf-modal
    height 100vh
    width 100vw
    position fixed
    top 0
    left 0
    z-index 8
    background rgba( 0 0 0 .5 )
    // @media( min-width: 1080px )
    //   box-sizing border-box
    //   padding-left var(--width-nav)

    &.align-left
      text-align left

    >>> .container
      animation-name appear
      animation-duration 640ms
      width 100vw - 20px
      background white
      padding 24px
      box-shadow var(--shadow-box)
      border-radius 7px
      border 1.5px solid rgb( 240 160 80 ) //var(--clr-blue-light)
      .emphasize
        font-weight bold
        margin 0 .25em
      p
        margin-top 16px
        line-height 1.5
      .heading, .primary
        color var(--clr-blue-light)
        font-weight bold
        cursor pointer
      .acknowledge-button
        text-align right
        margin-top 32px
        display block
        cursor pointer
      .button
        cursor pointer
      ol
        list-style-type decimal
        padding 8px 12px
        line-height 1.4
      .buttons
        margin-top 32px
        *
          margin 0

    >>> .container.wide
      width 320px

    >>> .container.wider
      width 480px

    >>> .container.widest
      width 100vw - 20px
</style>
